import { HttpProvider } from "../http/http.provider";
import { IAppConfig } from "../http/types/IApplicationConfig";

import { addProvider, IProviderDescriptor, ServiceEndpointConstants } from "../ServiceUtil";
import { Observable } from "rxjs";
import { share, map } from "rxjs/operators";
import
{
    INewEmployeePayroll,
    IUpdateEmployeeAdvance,
    INewEmployeeExpenseDocument,
    IEmployeeExpense,
    INewEmployeePaystub,

    INewEmployeeTaxDocument,
    IPayroll,
    ITaxDocument,
    INewEmployeeCheck,
    IUpdateEmployeeCheck
} from "./payroll.interface";
import { createFormData } from "../util/utilities";
import { IHttpRequestConfig } from "../http";
import { IEmployeePayrollUpdate, INewEmployeeInsurance, INewEmployeePayrollUpdate } from "../EmployeeService";

/**
 * 
 */

export class PayrollDelegate
{

    constructor(private SERVICE_CONFIG: IAppConfig, private http: HttpProvider)
    {
    }

    public getEmployeePaystubsByPayrollDate(payrollRecordId: string): Observable<IPayroll[]>
    {
        const config: IHttpRequestConfig = {
            params: {
                payrollRecordId: payrollRecordId
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.PAYROLL.GET_EMPLOYEE_PAYROLL, null, config).pipe(
            map((response: any) =>
            {
                return this.normalizePaystubs(response.data.employeePaystubs);

            }),
            share());
    }


    public getTaxesByYear(taxYear: number, orgId:string): Observable<ITaxDocument[]>
    {
        const config: IHttpRequestConfig = {
            params: {
                orgId:orgId,
                taxYear: taxYear
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.PAYROLL.GET_EMPLOYEE_TAXES, null, config).pipe(
            map((response: any) =>
            {
                return this.normalizeTaxes(response.data.employeeTaxDocs);

            }),
            share());
    }

    public getAllEmployeeChecks(orgId: string): Observable<any>
    {
        const config: IHttpRequestConfig = {
            params: {
                OrgId: orgId
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.PAYROLL.GET_EMPLOYEE_CHECKS, null, config).pipe(share());
    }

    public createNewEmployeePayrollUpdate(newEmpInsurance: INewEmployeePayrollUpdate): Observable<any>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.PAYROLL.CREATE_EMPLOYEE_PAYROLL_UPDATE, newEmpInsurance).pipe(share());
    }

    public updateEmployeePayrollUpdate(newEmpInsurance: IEmployeePayrollUpdate): Observable<any>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.PAYROLL.UPDATE_EMPLOYEE_PAYROLL_UPDATE, newEmpInsurance).pipe(share());
    }

    public createNewEmployeeInsurance(newEmpInsurance: INewEmployeeInsurance): Observable<any>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.PAYROLL.CREATE_EMPLOYEE_INSURANCE, newEmpInsurance).pipe(share());
    }

    public updateEmployeeInsurance(newEmpInsurance: INewEmployeeInsurance): Observable<any>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.PAYROLL.UPDATE_EMPLOYEE_INSURANCE, newEmpInsurance).pipe(share());
    }

    public getEmployeePayrollUpdate(orgId: string, year: number, updateType: string): Observable<any>
    {
        const config: IHttpRequestConfig = {
            params: {
                OrgId: orgId,
                Year: year,
                UpdateType: updateType
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.PAYROLL.GET_EMPLOYEE_PAYROLL_UPDATE, null, config).pipe(
            map((response: any) =>
            {
                return response.data.employeePayrollUpdates;

            }),
            share());
    }

    public getEmployeeInsurance(orgId: string, year: number, status: boolean): Observable<any>
    {
        const config: IHttpRequestConfig = {
            params: {
                OrgId: orgId,
                Year: year,
                Status: status
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.PAYROLL.GET_EMPLOYEE_INSURANCE, null, config).pipe(
            map((response: any) =>
            {
                return response.data.employeeInsurances;

            }),
            share());
    }

    public createNewEmployeeAdvance(newEmployeeAdvance: INewEmployeeCheck): Observable<any>
    {
        const formdata = createFormData(newEmployeeAdvance);

        return this.http.post(ServiceEndpointConstants.endpoints.PAYROLL.LINK_EMPLOYEE_CHECK, formdata).pipe(share());
    }

    public createNewEmployeePaystub(newEmployeePaystub: INewEmployeePaystub): Observable<any>
    {
        const formdata = createFormData(newEmployeePaystub);

        return this.http.post(ServiceEndpointConstants.endpoints.PAYROLL.CREATE_EMPLOYEE_PAYSTUB, formdata).pipe(share());
    }

    public createNewEmployeeTaxDocument(newTaxDocument: INewEmployeeTaxDocument): Observable<any>
    {
        const formdata = createFormData(newTaxDocument);

        return this.http.post(ServiceEndpointConstants.endpoints.PAYROLL.CREATE_EMPLOYEE_TAX_DOCUMENT, formdata).pipe(share());
    }

    public updateEmployeeAdvance(updateEmployee: IUpdateEmployeeCheck): Observable<any>
    {
        const formdata = createFormData(updateEmployee);

        return this.http.post(ServiceEndpointConstants.endpoints.PAYROLL.UPDATE_EMPLOYEE_CHECK, formdata).pipe(share());
    }

    public getAllEmployeeRefunds(orgId: string): Observable<any>
    {
        const config: IHttpRequestConfig = {
            params: {
                OrgId: orgId
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.PAYROLL.GET_ALL_EMPLOYEE_REFUND, null, config).pipe(share());
    }

    public createEmployeeRefund(employeeRefund: INewEmployeePayroll): Observable<any>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.PAYROLL.CREATE_EMPLOYEE_REFUND, employeeRefund).pipe(share());
    }

    public getAllEmployeeExpenses(orgId: string): Observable<any>
    {
        const config: IHttpRequestConfig = {
            params: {
                OrgId: orgId
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.PAYROLL.GET_ALL_EMPLOYEE_EXPENSE, null, config).pipe(share());
    }

    public createEmployeeExpense(employeeExpenses: IEmployeeExpense): Observable<any>
    {
        const formdata = createFormData(employeeExpenses);
        return this.http.post(ServiceEndpointConstants.endpoints.PAYROLL.CREATE_EMPLOYEE_EXPENSE, formdata).pipe(share());
    }

    public uploadExpenseDocument(file: INewEmployeeExpenseDocument): Observable<any>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.PAYROLL.UPLOAD_EMPLOYEE_EXPENSE_DOCUMENT, file).pipe(share());
    }

    private normalizePaystubs(payStubs: any): IPayroll[]
    {
        return payStubs.map(payStub =>
        {
            return {
                employeePayrollId: payStub.employeePayrollId,
                employeePayrollDate: payStub.employeePayrollRecord.payDateToString,
                fileLocationPath: payStub.fileLocationPath,
                fileName: payStub.fileName,
                employeeFullName: payStub.employee ? payStub.employee.employeeFullName : '',
                hideCheck: payStub.hideCheck
            } as IPayroll;
        });
    }

    private normalizeTaxes(taxes: any): ITaxDocument[]
    {
        return taxes.map(tax =>
        {
            return {
                employeeTaxDocumentId: tax.employeeTaxDocumentId,
                taxDoucmentType: tax.taxDocType,
                fileLocationPath: tax.fileLocationPath,
                fileName: tax.fileName,
                employeeFullName: tax.employee ? tax.employee.employeeFullName : '',
                taxYear: tax.taxYear
            } as ITaxDocument;
        });
    }
}